// The Daikin VRV range, exactly as the VRV page (/daikin-vrv-systems) shows
// it. The VRV page and the 41 location pages both read this file, so the two
// can never drift apart (Oct 2026: Saheb wants the location pages to show the
// range the same way the VRV page does — same cards, same images, same words).
//
// No imports: scripts/prerender.js evaluates this file directly.

export const VRV_PRODUCTS = [
  {
    name: 'VRV Alpha / VRV X', tag: 'AI-Powered', desc: 'Daikin\'s most intelligent system — AI learns patterns and optimises energy automatically.',
    features: ['AI-based intelligent control software', 'IoT remote monitoring & diagnostics', 'Exceeds BEE 2026 energy standards', 'Reliable up to 55°C ambient temp', 'Connect up to 64 indoor units', 'Compact & flexible installation'],
    ideal: 'Corporate offices, hospitals, hotels, retail, high-end residences',
    image: '/Daikin VRV Alpha.webp',
    alt: 'Daikin VRV X HVAC system for commercial buildings Delhi NCR',
  },
  {
    name: 'VRV Home', tag: 'Residential', desc: 'Replace all outdoor units with just one. Designed for homes, apartments and villas.',
    features: ['Up to 8 indoor units on 1 outdoor unit', 'Single-phase power — no 3-phase needed', 'Brazing-free quick installation', 'Whisper-quiet swing compressor', 'Works from 0°C to 46°C', 'Duct & hi-wall indoor options'],
    ideal: '2BHK–5BHK apartments, independent floors',
    image: '/Daikin VRV Home Series.webp',
    alt: 'Daikin VRV Home residential central air conditioning system Delhi NCR',
  },
  {
    name: 'VRV Side Discharge', tag: 'Space Efficient', desc: 'Full VRV performance in a compact side-discharge outdoor unit for tight spaces.',
    features: ['Side-discharge fits narrow spaces', 'Smaller footprint than top-discharge', 'Wall-mounted or enclosed install', 'Lower noise for close-proximity', 'Easy front-panel maintenance', 'Full VRV efficiency retained'],
    ideal: 'Urban buildings, renovations, retrofit projects, space-constrained sites',
    image: '/Daikin VRV S.webp',
    alt: 'Daikin VRV Side Discharge compact outdoor unit for urban buildings Delhi NCR',
  },
];
